import LoginForm from '../components/organism/forms/LoginForm'

const Login = () => <LoginForm />

export default Login
